/**
 * MODAL
 *
 * Js for the common modal component.
 *
 * USAGE:
 *
 * Use the following dom structure:
 *
 * <div id="unique_modal_id" data-bb-modal="true">
 *   <div class="bb-modal-title">
 *       <span class="">Title or logo</span>
 *       <a href="#" data-bb-modal-close class="bb-modal-close"></a>
 *  </div>
 *  <div class="bb-modal-content">
 *       <div class="bb-modal-page bb-modal-current-page" data-page-id="0">
 *           <div class="bb-modal-header">
 *           </div>
 *          <!-- page 0 content here -->
 *      </div>
 *      <div class="bb-modal-page" data-page-id="1">
 *          <div class="bb-modal-header">
 *              <a href="#" data-bb-modal-back class="bb-modal-back"></a>
 *          </div>
 *          <!-- page 1 content here -->
 *      </div>
 *  </div>
 * </div>
 */

import $ from 'jquery';
import { getState } from '../../../shared/utils/state';
import './style.scss';
import { kickUser } from '../../../spa/Utils/WrapperIntegration/Ucf';

const jQuery = $;

var currentOverlayZindex = 11011;
/* exported bbModal, bbModal_open, bbModal_close, bbModal_changePage*/
var bbModal = function(component) {
    this.component = component;
    this.overlay = null;
    this.visitedPages = [0]; // The first page visited is the home (id: 0)
    this.overlayDialog = null;
    this.overlayDialogOpen = false;
    this.init();
};

/**
 * Initializes the DOM object component to act as a modal
 * @param  {jQuery} component
 * @return {bbModal} The bbModal object itself
 */
bbModal.prototype.init = function() {
    var body = $('body');
    // We want to get common overlay for all modals.
    // This is special one with attribute `data-forced-overlay=false`.
    // Should be only one in DOM (singleton).
    var overlay = body.find('.bb-modal-overlay[data-forced-overlay!=true]').first();

    this.component.addClass('bb-modal bb-modal-initialized');
    // Component's default distance from top
    this.componentDefaultTop = parseInt(this.component.css('top'), 10);

    // By default avoid creating more than one overlay.
    // You have to explicitly set `data-force-next-overlay` on modal.
    // It allows you to open multiple modals at once.
    // All modals with `data-force-next-overlay=true` has own overlay with `data-forced-overlay=true`
    this.forceOwnOverlay = Boolean(this.component.data('force-next-overlay'));
    if (!overlay.length || this.forceOwnOverlay) {
        overlay = $('<div class="bb-modal-overlay" data-bb-modal-close data-forced-overlay="' + this.forceOwnOverlay + '"></div>');
        body.append(overlay);
    }

    var overlayDialogHtml = '<div class="bb-modal-overlay-dialog-overlay" data-bb-modal-overlay-dialog-close>';
    overlayDialogHtml += '<div class="bb-modal-overlay-dialog">';
    overlayDialogHtml += '<div class="bb-modal-overlay-dialog-content"></div></div></div>';
    var overlayDialog = $(overlayDialogHtml);

    this.component.append(overlayDialog);

    this.overlay = overlay;
    this.overlayDialog = overlayDialog;
    this.component.trigger('bbModal.init');
};

/**
 * Open (shows) an already initialized modal
 */
bbModal.prototype.open = function(mode) {
    if (mode == 'slideIn') {
        this.component.trigger('bbModal:opened', mode);
    } else {
        var scrolledDistance = $(window).scrollTop();
        this.component.css('top', this.componentDefaultTop + scrolledDistance + 'px');
        this.component.addClass('bb-modal-visible');
        this.overlay.addClass('bb-modal-overlay-visible');
        if (this.component.hasClass('bb-modal--full-size')) {
            $('body').addClass('full-size-modal');
        }
        // Notify rest of the site that modal is opened
        this.component.trigger('bbModal:opened');
        // If `forceOwnOverlay` is set to true modal need to have own overlay.
        // Infinitely increases z-index for each new modal open.
        // Use this value as modal ID, to make it easier to identify them.
        if (this.forceOwnOverlay) {
            currentOverlayZindex++;
            this.overlay.attr('data-modal-id', currentOverlayZindex);
            this.overlay.css('z-index', currentOverlayZindex);
            this.component.attr('data-modal-id', currentOverlayZindex);
            this.component.find('[data-bb-modal-close]').attr('data-modal-id', currentOverlayZindex);
            this.component.css('z-index', currentOverlayZindex+1);
        }
    }
};

/**
 * Close (hides) an already initialized modal
 */
bbModal.prototype.close = function(mode) {
    if (this.overlayDialogOpen) {
        this.closeOverlayDialog();
        return;
    }

    if (mode == 'slideIn') {
        this.component.trigger('bbModal:closed', mode);
    } else {
        this.component.removeClass('bb-modal-visible');
        this.overlay.not('.overlay-for-second-modal').removeClass('bb-modal-overlay-visible');
        if (this.component.hasClass('bb-modal--full-size')) {
            $('body').removeClass('full-size-modal');
        }
        // Notify rest of the site that modal is closed
        this.component.trigger('bbModal:closed');
    }
};

/**
 * Records a page change in the history
 * @param  {int} page The page ID
 */
bbModal.prototype.recordPageChange = function(page) {
    this.visitedPages.push(page);
};

/**
 * Returns a list of visited pages
 * @return {Array}
 */
bbModal.prototype.getVisitedPages = function() {
    return this.visitedPages;
};

bbModal.prototype.goBack = function() {
    this.visitedPages.pop();
    if (this.visitedPages.length) {
        return this.changePage(this.visitedPages[this.visitedPages.length - 1], true);
    }

    return false;
};

bbModal.prototype.changePage = function(page, doNotRecord) {
    var pages = this.component.find('.bb-modal-page');
    var targetPage = pages.filter('[data-page-id="' + page + '"]');

    if (!targetPage.length) {
        return false;
    }

    pages.removeClass('bb-modal-current-page');
    targetPage.addClass('bb-modal-current-page');

    if (!doNotRecord) {
        this.recordPageChange(page);
    }
    // Notify rest of the site that modal page is changed
    targetPage.trigger('bbModal:pageChanged', page);
    return true;
};

bbModal.prototype.openOverlayDialog = function(classes, openEvenIfModalClosed) {
    if (this.component.hasClass('bb-modal-visible') || Boolean(openEvenIfModalClosed)) {
        this.overlayDialog.addClass('bb-modal-overlay-visible')
            .find('.bb-modal-overlay-dialog')
            .removeAttr('class')
            .addClass('bb-modal-overlay-dialog betslip-dialog bb-modal-overlay-dialog-visible')
            .addClass(classes);
        this.overlay.addClass('bb-modal-overlay-for-dialog');
        this.overlayDialogOpen = true;
        this.component.trigger('bbModal:overlayDialogOpen');
    }
};

bbModal.prototype.closeOverlayDialog = function() {
    if (this.overlayDialogOpen) {
        this.overlayDialog.removeClass('bb-modal-overlay-visible')
            .find('.bb-modal-overlay-dialog')
            .removeClass('bb-modal-overlay-dialog-visible');
        this.overlay.removeClass('bb-modal-overlay-for-dialog');
        this.overlayDialogOpen = false;
        this.component.trigger('bbModal:overlayDialogClose');
    }

};

bbModal.prototype.loadOverlayDialogContent = function(content) {
    var $dialogContent = this.overlayDialog
        .find('.bb-modal-overlay-dialog-content')
        .html(content);

    setTimeout(function resetScrollingPosition() {
        $dialogContent.scrollTop(0);
    }, 0);
};

bbModal.prototype._hideLoadingSpinner = function() {
    if (typeof window.bbLoader !== 'undefined') {
        window.bbLoader('hide');
    }
};

jQuery.fn.bbModal = function() {
    return this.each(function() {
        var component = $(this);
        var modal = new bbModal(component);
        component.data('bbModal', modal);
        var id = component.attr('id');
        var selectorsPrefix = '#' + id;

        var hideVisibleModals = function() {
            $('.bb-modal-visible').not('.base-modal-for-second-layer').each(function(index, item) {
                bbModal_close('#' + $(item).attr('id'));
            });
        };

        $('[data-bb-modal-close-modals]').on('click', hideVisibleModals);

        /** Initializes launch points for this modal, only for modals rendered on siteload */
        $(document).on('click', '[data-bb-modal-launch="' + id + '"]', function onModalLaunchPointClick (event) {
            var $modalLauncher = $(event.target);
            var mode = $(this).closest('[data-bb-modal-mode]').data('bbModalMode') || 'overlay';
            if (this.hasAttribute('data-bb-modal-close-modals')) {
                hideVisibleModals();
            }
            if ($modalLauncher.attr('data-bb-modal-as-second-layer')) {
                bbModal_init2ndModal($modalLauncher.parents('[data-bb-modal]'));
            }
            modal.open(mode);
            modal._hideLoadingSpinner();
            return false;
        });

        /** Initializes changePage points for this modal */
        component.on('click', '[data-bb-modal-changePage]', function onModalChangePageClick () {
            modal.changePage($(this).attr('data-bb-modal-changePage'));
        });

        $(document).on('click', '[data-bb-modal-toggle="' + id + '"]', function onModalTogglePointClick () {
            var mode;
            var bbModalMode = $(this).closest('[data-bb-modal-mode]');

            if (bbModalMode.length > 0) {
                mode = bbModalMode.data('bb-modal-mode');
            }

            if (!$(component).data('bb-modal-shown')) {
                $(component).data('bb-modal-shown', true);
                modal.open(mode);
                modal._hideLoadingSpinner();
            } else {
                $(component).data('bb-modal-shown', false);
                modal.close(mode);
                modal._hideLoadingSpinner();
            }
            return false;
        });

        /** Initializes goBack points */
        $(document).on('click', selectorsPrefix + ' [data-bb-modal-back]', function onModalGoBackClick () {
            modal.goBack();
            modal._hideLoadingSpinner();
            return false;
        });

        $(document).on('click', selectorsPrefix + ' [data-bb-modal-overlay-dialog-close]', function onModalOverlayDialogCloseClick () {
            modal.closeOverlayDialog();
            modal._hideLoadingSpinner();
            return false;
        });

        $(document).on('click', selectorsPrefix + ' [data-bb-modal-kickuser]', function onModalOverlayNavigateClick () {
            modal.closeOverlayDialog();
            modal._hideLoadingSpinner();
            kickUser();

            return false;
        });

        $(document).on('click', selectorsPrefix + ' [data-bb-modal-external-navigate]', function onModalOverlayNavigateClick () {
            const url = $(this).data('bb-modal-external-navigate');
            modal.closeOverlayDialog();
            modal._hideLoadingSpinner();
            /**
             * @todo AM-3445 Abstract to Ucf.js
             */
            uc.channels.crm.topics.CTA_ExternalLink_Open.publish({ publisher: 'spectate-client' }, { Url: url });

            return false;
        });

        $(document).on('click', selectorsPrefix + ' .bb-modal-overlay-dialog', function onModalOverlayDialogClick (e) {
            e.stopPropagation();
        });
    });
};

/* Open a selected modal on the fly */
export function bbModal_open (component) {
    var modal = $(component).data('bbModal');
    var mode = $(component).closest('[data-bb-modal-mode]').data('bbModalMode') || 'overlay';

    $(component).data('bb-modal-shown', true);

    modal.open(mode);
    modal._hideLoadingSpinner();
    return false;
}

/** Programmatically close a modal */
export function bbModal_close (component) {
    var modal = $(component).data('bbModal');
    var mode = $(component).closest('[data-bb-modal-mode]').data('bbModalMode') || 'overlay';

    $(component).data('bb-modal-shown', false);

    modal.close(mode);
    modal._hideLoadingSpinner();
    return false;
}

/* Change modal current page without having to trigger the click event */
export function bbModal_changePage(component, page) {
    var modal = $(component).data('bbModal');
    modal.changePage(parseInt(page, 10));
    modal._hideLoadingSpinner();
    return false;
}

/**
* makes an already opened modal to a base modal from which another modal is opened.
* The so called "second-modal-modus".
*/
export function bbModal_init2ndModal($baseModalFor2ndModal) {

    $baseModalFor2ndModal.addClass('base-modal-for-second-layer');

    // setup second-modal-modus: change overlay and use already
    // loaded modals by changing display position
    $('.bb-modal-overlay').addClass('overlay-for-second-modal').
        on('click', function(e) {
            e.stopPropagation();
        });
    $('body').addClass('second-modal-modus');
}

export function bbModal_end2ndModalMode() {
    var $body = $('body');

    // return to standard overlay (one modal), exit second-modal-modus
    if ($body.hasClass('second-modal-modus')) {
        $('.overlay-for-second-modal').
            off('click').
            removeClass('overlay-for-second-modal');
        $('.base-modal-for-second-layer').removeClass('base-modal-for-second-layer');

        $body.removeClass('second-modal-modus');
    }
}

export function createBbModal(el) {
    return $(el).bbModal();
}

export function createCloseEvents() {
    /** Initializes close points */
    $(document).on('click', '[data-bb-modal-close], .bb-modal-overlay', function(e) {
        e.stopImmediatePropagation();
        var $currentModal;
        var modalId = $(this).attr('data-modal-id');
        // If have specified ID we have more than one modal on page
        // Choose this specific one.
        if (modalId) {
            $currentModal = $('[data-modal-id=' + modalId + '][data-bb-modal]');
        } else {
            // If no modal ID, we have only one modal available in DOM.
            $currentModal = $('[data-bb-modal].bb-modal-initialized:visible');

            // The above statement is not true anymore for desktop, because of the betslip always present.
            // If currentModal.length is > than 1, then there is a modal + betslip on the screen, so avoid closing the betslip
            if ($currentModal.length > 1) {
                $currentModal = $currentModal.filter(':not(#betslip)');
            }
        }
        var modal = $currentModal.data('bbModal');
        var mode = 'overlay';
        var bbModalMode = $(this).closest('[data-bb-modal-mode]');

        if (bbModalMode.length > 0) {
            mode = bbModalMode.data('bb-modal-mode');
        }

        modal.close(mode);
        bbModal_end2ndModalMode();
        modal._hideLoadingSpinner();
        return false;
    });
}

export function bbModal_DOMInit() {
    $(document).on("ready pageinit", function() {
        $('[data-bb-modal]:not(.bb-modal-initialized)').bbModal();
    });
}
